import { post } from "@utils/fetch";

type RequestOauthTokenInput = {
  provider: "google";
};

type RequestOauthTokenResponse = {
  url: string;
};

export const requestOauthToken = async (
  input: RequestOauthTokenInput,
): Promise<RequestOauthTokenResponse> => {
  const { data } = await post("/api/public/v1/auth/oauth-discovery/", input);

  return data;
};
